import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
// components
import { FormattedMessage } from 'dibs-react-intl';
import { ExpandingAreaWithReadMore } from 'dibs-elements/exports/ExpandingArea';
import TranslationToggle from 'dibs-elements/exports/TranslationToggle';
import {
    useItemTranslations,
    INTERFACE_STATE,
} from '../PdpSharedOriginalLanguageProvider/PdpSharedOriginalLanguageProvider';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import classNames from 'classnames';

export const Title = () => (
    <FormattedMessage id="PdpSharedDescriptionAbout.aboutHeader" defaultMessage="About" />
);

export const Content = ({
    description,
    englishDescription,
    contentClass,
    collapsedHeight,
    showExpandingArea = true,
    showOriginal,
}) => {
    if (!description) {
        return null;
    }
    const descriptionToShow = showOriginal ? englishDescription : description;

    const content = (
        <span
            className={classNames(styles.content, contentClass)}
            data-tn="pdp-item-description-content"
            dangerouslySetInnerHTML={{ __html: (descriptionToShow || '').trim() }}
        />
    );
    return (
        <>
            {showExpandingArea ? (
                <ExpandingAreaWithReadMore
                    collapsedHeight={collapsedHeight || 192}
                    showGradient={false}
                >
                    {content}
                </ExpandingAreaWithReadMore>
            ) : (
                content
            )}
        </>
    );
};

Content.propTypes = {
    description: PropTypes.string,
    englishDescription: PropTypes.string,
    contentClass: PropTypes.string,
    collapsedHeight: PropTypes.number,
    showExpandingArea: PropTypes.bool,
    showOriginal: PropTypes.bool,
};

const PdpSharedDescriptionAboutComponent = ({
    item,
    contentClass,
    headerClass,
    collapsedHeight,
    showExpandingArea,
}) => {
    const [state, dispatch] = useItemTranslations();
    if (!item || !item.description) {
        return null;
    }

    return (
        <div data-tn="pdp-item-description" className={styles.wrapper}>
            <div className={styles.headerContainer}>
                <h2
                    className={classNames(styles.header, headerClass)}
                    data-tn="pdp-item-description-title"
                >
                    <Title />
                </h2>
                <TranslationToggle
                    className={styles.translationToggleContainer}
                    currentState={state?.interfaceState}
                    onClick={() => dispatch({ type: 'TOGGLE_TRANSLATIONS' })}
                />
            </div>
            <Content
                description={item.description}
                englishDescription={state?.data?.viewer?.item?.description}
                showOriginal={state?.interfaceState === INTERFACE_STATE.SHOW_ORIGINAL}
                contentClass={contentClass}
                collapsedHeight={collapsedHeight}
                showExpandingArea={showExpandingArea}
            />
        </div>
    );
};

PdpSharedDescriptionAboutComponent.propTypes = {
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    item: PropTypes.object.isRequired,
    collapsedHeight: PropTypes.number,
    showExpandingArea: PropTypes.bool,
};

export const PdpSharedDescriptionAbout = createFragmentContainer(
    PdpSharedDescriptionAboutComponent,
    {
        item: graphql`
            fragment PdpSharedDescriptionAbout_item on Item {
                description
            }
        `,
    }
);
